<template>
	<div>
		<v-dialog v-model="reorder_dialog" no-click-animation persistent scrollable content-class="full-height select_field_dialog" lazy transition="dialog-bottom-transition">
	        <v-card>
	        	<v-card-title noshadow class="dialog_searchbox">
	        		<v-subheader full-width>Reorder Sections</v-subheader>
	        	</v-card-title>
	        	<v-divider></v-divider>
		        <v-card-text full-height nopadding>
		        	<v-list subheader nopadding>
						<Container @drop="fn_applyDrag" class="simple-page" lock-axis="y">
							<Draggable v-for="(item, sIndex) in sections" :key="sIndex">
							
								<v-list-tile class="draggable-item">
									<v-list-tile-content>
										<v-list-tile-title>{{item.section.sectionName}}</v-list-tile-title>
									</v-list-tile-content>
									<v-list-tile-action>
										<v-icon>reorder</v-icon>
									</v-list-tile-action>
								</v-list-tile>	

								<v-divider v-if="sections.length-1 != sIndex"></v-divider>
								
							</Draggable>
						</Container>
					</v-list>
		        </v-card-text>
		        <v-divider></v-divider>
		        <v-card-actions>
		        	<v-spacer></v-spacer>
          			<v-btn small color="blue darken-1" flat @click="$parent.fn_closeDialog">close</v-btn>
		          	<v-btn small color="blue darken-1" flat @click="applyReorder(sections)">ok</v-btn>
		        </v-card-actions>
		    </v-card>


	    </v-dialog>
	</div>
</template>

<!-- <template>
	<div>

		<v-list :id="fieldItem.section.elementId" two-line subheader nopadding>
			<Container @drop="applyDrag" class="simple-page" lock-axis="y">
				<Draggable v-for="(fieldItem, sIndex) in fieldItems" :key="sIndex">
				
					<v-list-tile class="draggable-item">
						<v-list-tile-content>
							<v-list-tile-title>{{fieldItem.section.sectionName}}</v-list-tile-title>
						</v-list-tile-content>
						<v-list-tile-action>
							<v-icon>reorder</v-icon>
						</v-list-tile-action>
					</v-list-tile>	
					
				</Draggable>
			</Container>
		</v-list>
	</div>
</template> -->

<script>
import { Container, Draggable } from "vue-smooth-dnd";

	export default{
		components: { Container, Draggable },
		props:['fieldItems', 'applyReorder'],
		data(){
			return{
				reorder_dialog:false,
				sections:[]
			}
		},
		methods:{
			openDialogWeb: function () {
				this.sections = [];
				this.sections = JSON.parse(JSON.stringify(this.fieldItems));
				this.reorder_dialog = true;
			},
			closeDialogWeb: function () {
				this.reorder_dialog = false;
			},
			fn_applyDrag: function (dropResult) {
			    this.sections = this.fn_implementDrag(this.sections, dropResult);
			},
			fn_implementDrag: function (arr, dragResult) {
				const { removedIndex, addedIndex, payload } = dragResult
				  if (removedIndex === null && addedIndex === null) return arr

				  const result = [...arr]
				  let itemToAdd = payload

				  if (removedIndex !== null) {
				    itemToAdd = result.splice(removedIndex, 1)[0]
				  }

				  if (addedIndex !== null) {
				    result.splice(addedIndex, 0, itemToAdd)
				  }

			  	return result
			},
		}
	}
</script>this.


// WEBPACK FOOTER //
// src/components/fields/reorder_section.vue